import {all, call, put, takeEvery} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import * as actions from '../actions/action_analytics';
import {generateAnalyticsId} from '../utils/analytics';

export function* analyticsRequested({payload}) {
    const {startDate, endDate, instanceType} = payload;
    try {
        const response = yield call(api.fetchAnalytics, payload.type, {...payload.params, startDate, endDate, instanceType});
        yield put(actions.analyticsSuccess(payload.id, response.data));
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        yield put(actions.analyticsFailure(payload.id, error));
    }
}

export function* analyticsBatchRequested({payload}) {
    const {items, startDate, endDate, instanceType} = payload;
    for (const it of items) {
        yield put(actions.analyticsLoading(it.id));
    }
    try {
        const requests = items.map((it) => ({
            type: it.type,
            params: {...it.params, startDate, endDate, instanceType},
        }));
        const response = yield call(api.fetchAnalyticsBatch, requests);
        const results = response.data.results;
        for (let i = 0; i < items.length; i++) {
            const r = results[i];
            if (r.ok) {
                yield put(actions.analyticsSuccess(items[i].id, r.data));
            } else {
                yield put(actions.analyticsFailure(items[i].id, r.error));
            }
        }
    } catch (error) {
        if (error.response && error.response.status === 401) {
            yield put(logout());
        }
        for (const it of items) {
            yield put(actions.analyticsFailure(it.id, error));
        }
    }
}

export function* dashboardSuccess({payload}) {
    const {startDate, endDate, instanceType} = payload;
    const widgets = payload.item.widgets;
    const standalone = widgets.filter((w) => constants.BATCH_EXCLUDED_WIDGET_TYPES.includes(w.type));
    const batchable = widgets.filter((w) => !constants.BATCH_EXCLUDED_WIDGET_TYPES.includes(w.type));

    for (const w of standalone) {
        const id = generateAnalyticsId(w);
        yield put(actions.requestAnalytics(id, w.type, w.params, startDate, endDate, instanceType));
    }
    for (let i = 0; i < batchable.length; i += constants.BATCH_ANALYTICS_SIZE) {
        const chunk = batchable.slice(i, i + constants.BATCH_ANALYTICS_SIZE);
        const items = chunk.map((w) => ({id: generateAnalyticsId(w), type: w.type, params: w.params}));
        yield put(actions.requestAnalyticsBatch(items, startDate, endDate, instanceType));
    }
}

export default function* root() {
    yield all([
        takeEvery(constants.ANALYTICS_REQUESTED, analyticsRequested),
        takeEvery(constants.ANALYTICS_BATCH_REQUESTED, analyticsBatchRequested),
        takeEvery(constants.DASHBOARD_SUCCESS, dashboardSuccess),
    ]);
}
